import { cmsImageUrl } from "src/lib/cmsImageUrl";

export const CONSISTENCY_SCORE_ARTICLE_URLS = {
  EVERNORTH: "https://join9am.com/blog/consistency-score-evernorth",
  BNY: "https://join9am.com/blog/consistency-score-bny",
  HWJ: "https://join9am.com/blog/consistency-score-hwj",
  NON_HWJ: "https://join9am.com/blog/consistency-score-non-hwj",
  KWIK_TRIP:
    "https://join9am.com/blog/your-9amhealth-consistency-score-kwiktrip"
};
export interface RefillArticleConfig {
  url: string;
  imageSrc: string;
  readingMinutes: number;
}

export interface RefillArticlesConfig {
  managingSideEffects: RefillArticleConfig;
  understandingGlp1: RefillArticleConfig;
  consistencyScore: RefillArticleConfig;
}

export const REFILL_ARTICLES_CONFIG: RefillArticlesConfig = {
  managingSideEffects: {
    url: "https://join9am.com/blog/managing-common-digestive-side-effects-of-glp-1-medications",
    imageSrc: cmsImageUrl(
      "1f49e3b99371ca6ad78f617fb3dd2ad27702ad7d-480x320.jpg"
    ),
    readingMinutes: 5
  },
  understandingGlp1: {
    url: "https://join9am.com/blog/understanding-glp-1-medications",
    imageSrc: cmsImageUrl(
      "a474f08829a547ca9e73bceb9225a28c4cdf7bb1-1750x875.png"
    ),
    readingMinutes: 5
  },
  consistencyScore: {
    url: "https://join9am.com/blog/understanding-your-consistency-score-for-weight-loss-refills",
    imageSrc: cmsImageUrl(
      "54db41e07db1325a8491e377e77d450fd4453a12-1920x1080.png"
    ),
    readingMinutes: 3
  }
};
